import usePopupState from "@/components/Vacancy/PopupState";
import VacancyLayout from "@/components/Vacancy/VacancyLayout";
import React, { useEffect, useState } from "react";
import { WithUserLayout } from "@/components/UserLayout";
import { GetVacanciesList } from "@/services/VacancyService";
import { useSession } from "next-auth/react";

const VacancyPage = () => {
  const { data: session } = useSession();

  const [id, setId] = useState('');

  useEffect(() => {
    if (session?.user) {
      setId(session.user["id"]);
    }
  }, [session]);
  
  const data = GetVacanciesList(id?id:'');
  const { popupState, setPopup } = usePopupState();
    
  return (
    <VacancyLayout
      isDetailPage={false}
      data={data}
      popupState={popupState}
      setPopup={setPopup}
      isApplied={false}
    />
  );
};

VacancyPage.layout = WithUserLayout;
export default VacancyPage;
